export default __webpack_public_path__ + "static/scam-alert-image-2-c3bd71c85892abb874fed35c516ac522.webp";